export const countryCodes = [
  {
    "country": "AT",
    "name": "Austria",
    "eu": true,
    "language": "de",
    "currency": "EUR",
    "pricelist": "25",
    "market": "1"
  },
  {
    "country": "DK",
    "name": "Denmark",
    "eu": true,
    "language": "da",
    "currency": "DKK",
    "pricelist": "24",
    "market": "1"
  },
  {
    "country": "EE",
    "name": "Estonia",
    "eu": true,
    "language": "en",
    "currency": "EUR",
    "pricelist": "25",
    "market": "1"
  },
  {
    "country": "FI",
    "name": "Finland",
    "eu": true,
    "language": "fi",
    "currency": "EUR",
    "pricelist": "25",
    "market": "1"
  },
  {
    "country": "DE",
    "name": "Germany",
    "eu": true,
    "language": "de",
    "currency": "EUR",
    "pricelist": "25",
    "market": "1"
  },
  {
    "country": "NO",
    "name": "Norway",
    "eu": false,
    "language": "no",
    "currency": "NOK",
    "pricelist": "23",
    "market": "1"
  },
  {
    "country": "SJ",
    "name": "Svalbard",
    "eu": false,
    "language": "no",
    "currency": "NOK",
    "pricelist": "28",
    "market": "1"
  },
  {
    "country": "SE",
    "name": "Sweden",
    "eu": true,
    "language": "sv",
    "currency": "SEK",
    "pricelist": "19",
    "market": "1"
  }
];